module.exports = __webpack_public_path__ + "img/realtime.08ad5314.jpg";